import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable, of, Subject } from 'rxjs';
import { DemoCase } from '../models/DemoCase';


@Injectable({
  providedIn: 'root'
})
export class CaseService {

  constructor(private http: HttpClient) { }

  getCases(): Observable<DemoCase[]> {
    return this.http.get<DemoCase[]>('assets/mock/data/demo-cases.json')
      .pipe(
        catchError(this.handleError<DemoCase[]>('getCases', []))
      );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
      // Let the app keep running by returning an empty result.
      return of(result as T);
    }
  }
}
